var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('hero-alt',{attrs:{"hero-alt":_vm.heroAlt}}),_c('v-container',{staticClass:"px-5"},[_c('v-row',{staticClass:"py-16 px-5"},[_c('v-col',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)],1)],1)],1),_c('location',{on:{"getContent":_vm.getContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }